import { createSlice } from "@reduxjs/toolkit";
const contactUserSlice = createSlice({
  name: "contactUserReducer",
  initialState: {
    contactUserListLoading: false,
    contactUserListData: null,
    contactUserListError: null,

    contactUserPushLoading: false,
    contactUserPushData: null,
    contactUserPushError: null,

    sendToNetcoreLoading: false,
    sendToNetcoreData: null,
    sendToNetcoreError: null,

    getSendToNetcoreLoading: false,
    getSendToNetcoreData: null,
    getSendToNetcoreError: null,
  },
  reducers: {
    getContactUserListLoading(state, action) {
      return {
        ...state,
        contactUserListLoading: true,
      };
    },
    getContactUserListSuccess(state, action) {
      return {
        ...state,
        contactUserListLoading: false,
        contactUserListData: action.payload,
      };
    },
    getContactUserListFailure(state, action) {
      return {
        ...state,
        contactUserListLoading: false,
        contactUserListError: action.payload,
      };
    },
    postContactUserPushLoading(state, action) {
      return {
        ...state,
        contactUserPushLoading: true,
      };
    },
    postContactUserPushSuccess(state, action) {
      return {
        ...state,
        contactUserPushLoading: false,
        contactUserPushData: action.payload,
      };
    },
    postContactUserPushFailure(state, action) {
      return {
        ...state,
        contactUserPushLoading: false,
        contactUserPushError: action.payload,
      };
    },
    clearPostContactUserPushSuccess(state, action) {
      return {
        ...state,
        contactUserPushData: null,
        contactUserPushError: null,
      };
    },
    postSendToNetcoreLoading(state, action) {
      return {
        ...state,
        sendToNetcoreLoading: true,
      };
    },
    postSendToNetcoreSuccess(state, action) {
      return {
        ...state,
        sendToNetcoreLoading: false,
        sendToNetcoreData: action.payload,
      };
    },
    postSendToNetcoreFailure(state, action) {
      return {
        ...state,
        sendToNetcoreLoading: false,
        sendToNetcoreError: action.payload,
      };
    },
    clearPostSendToNetcoreLoading(state, action) {
      return {
        ...state,
        sendToNetcoreData: null,
        sendToNetcoreError: null,
      };
    },
    getSendToNetcoreLoading(state, action) {
      return {
        ...state,
        getSendToNetcoreLoading: true,
      };
    },
    getSendToNetcoreSuccess(state, action) {
      return {
        ...state,
        getSendToNetcoreLoading: false,
        getSendToNetcoreData: action.payload,
      };
    },
    getSendToNetcoreFailure(state, action) {
      return {
        ...state,
        getSendToNetcoreLoading: false,
        getSendToNetcoreError: action.payload,
      };
    },
  },
});
export const {
  getContactUserListLoading,
  getContactUserListSuccess,
  getContactUserListFailure,

  postContactUserPushLoading,
  postContactUserPushSuccess,
  postContactUserPushFailure,
  clearPostContactUserPushSuccess,

  postSendToNetcoreLoading,
  postSendToNetcoreSuccess,
  postSendToNetcoreFailure,
  clearPostSendToNetcoreLoading,

  getSendToNetcoreLoading,
  getSendToNetcoreSuccess,
  getSendToNetcoreFailure,
} = contactUserSlice.actions;
export default contactUserSlice.reducer;
